import React from 'react';
import {Icon} from "@chakra-ui/react";

export const DownloadIcon = () => {
    return (
        <Icon width="12px" height="14px" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.3337 8.82161V11.4883C11.3337 12.2247 10.7367 12.8216 10.0003 12.8216H2.00033C1.26395 12.8216 0.666992 12.2247 0.666992 11.4883V8.82161M6.00033 9.48828L6.00033 1.48828M6.00033 9.48828L3.33366 6.82161M6.00033 9.48828L8.66699 6.82161" stroke="#FF3F3F" stroke-linecap="round" stroke-linejoin="round"/>
        </Icon>
    );
};

export default DownloadIcon;
